import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="14"
    height="10"
    viewBox="0 0 14 10"
    fill="transparent"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M1.66666 1H12.3333M1.66666 5H12.3333M1.66666 9H12.3333" />
  </svg>
);
